import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins, Emit } from "vue-property-decorator";
// QUINLAN
import Swal from "sweetalert2";
import BaseMixer from "@/router/views/BaseMixer";
let ConfirmationDialog = /** @class */ (() => {
    var _a;
    let ConfirmationDialog = class ConfirmationDialog extends Mixins(BaseMixer) {
        confirmationDialog() {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title slow-search",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                title: this.title,
                icon: "warning",
                confirmButtonColor: "#007ec2",
                confirmButtonText: "Okay",
            }).then(() => {
                return this.save();
            });
        }
        save() { }
        created() {
            this.confirmationDialog();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof String !== "undefined" && String) === "function" ? _a : Object)
    ], ConfirmationDialog.prototype, "title", void 0);
    __decorate([
        Emit(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ConfirmationDialog.prototype, "save", null);
    ConfirmationDialog = __decorate([
        Component({
            name: "ConfirmationDialog",
            components: {},
        })
    ], ConfirmationDialog);
    return ConfirmationDialog;
})();
export default ConfirmationDialog;
